module.exports = __webpack_public_path__ + "static/media/unity.639e923c.svg";